import type { FC } from 'react';
import { useParams, Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Breadcrumb from '@/components/base/Breadcrumb';

const articleDetailThumbnails: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20bedroom%20with%20soft%20moonlight%20through%20window%2C%20headphones%20resting%20on%20pillow%2C%20cream%20colored%20bedding%2C%20aromatherapy%20diffuser%20with%20gentle%20mist%2C%20wooden%20nightstand%2C%20minimalist%20peaceful%20composition%2C%20soft%20amber%20warm%20tones%2C%20editorial%20interior%20photography&width=1200&height=600&seq=art-det-01&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Old%20wooden%20library%20interior%20with%20tall%20bookshelves%2C%20warm%20amber%20lighting%20from%20table%20lamp%2C%20leather%20armchair%2C%20stack%20of%20old%20books%20on%20wooden%20table%2C%20dust%20particles%20in%20light%20beam%2C%20quiet%20atmosphere%2C%20cream%20and%20brown%20tones%2C%20editorial%20photography&width=1200&height=600&seq=art-det-02&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Crispy%20golden%20fried%20chicken%20on%20ceramic%20plate%2C%20glass%20of%20sparkling%20water%20with%20ice%2C%20warm%20kitchen%20lighting%2C%20wooden%20table%20surface%2C%20steam%20rising%2C%20minimalist%20food%20photography%2C%20cream%20and%20golden%20tones%2C%20soft%20shadows%2C%20editorial%20style&width=1200&height=600&seq=art-det-03&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Misty%20forest%20with%20gentle%20rain%2C%20small%20waterfall%20and%20stream%2C%20lush%20green%20moss%20on%20rocks%2C%20soft%20diffused%20light%20through%20trees%2C%20peaceful%20natural%20landscape%2C%20cream%20and%20sage%20green%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20nature%20photography&width=1200&height=600&seq=art-det-04&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Professional%20studio%20microphone%20with%20shock%20mount%20on%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20acoustic%20foam%20panels%20in%20background%2C%20headphones%20nearby%2C%20cozy%20dark%20atmosphere%20with%20amber%20glow%2C%20professional%20audio%20recording%20setup%2C%20minimalist%20composition&width=1200&height=600&seq=art-det-05&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Vintage%20typewriter%20and%20modern%20mechanical%20keyboard%20on%20wooden%20desk%2C%20warm%20lighting%2C%20coffee%20cup%20nearby%2C%20cream%20wall%2C%20minimalist%20workspace%2C%20soft%20shadows%2C%20editorial%20photography&width=1200&height=600&seq=art-det-06&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Spa%20massage%20room%20with%20soft%20candles%20and%20essential%20oils%2C%20warm%20wooden%20interior%2C%20white%20towels%20neatly%20folded%2C%20diffused%20warm%20lighting%2C%20peaceful%20meditation%20space%2C%20bamboo%20and%20stone%20elements%2C%20cream%20beige%20tones%2C%20editorial%20spa%20photography&width=1200&height=600&seq=art-det-07&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Cozy%20cafe%20interior%20on%20rainy%20day%2C%20warm%20lighting%2C%20espresso%20machine%2C%20window%20with%20raindrops%2C%20jazz%20vibe%2C%20wooden%20tables%20and%20chairs%2C%20cream%20and%20brown%20tones%2C%20editorial%20interior%20photography&width=1200&height=600&seq=art-det-08&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=Person%20wearing%20headphones%20relaxing%20on%20sofa%2C%20eyes%20closed%2C%20warm%20living%20room%2C%20peaceful%20expression%2C%20soft%20amber%20lighting%2C%20cream%20walls%2C%20minimalist%20interior%2C%20editorial%20portrait%20photography&width=1200&height=600&seq=art-det-09&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Colorful%20sponges%20on%20wooden%20surface%2C%20soft%20studio%20lighting%2C%20cream%20background%2C%20minimalist%20still%20life%2C%20various%20textures%20and%20shapes%2C%20warm%20beige%20tones%2C%20editorial%20product%20photography&width=1200&height=600&seq=art-det-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Soft%20feminine%20bedroom%20at%20night%2C%20fairy%20lights%20on%20wall%2C%20fluffy%20pillows%20and%20blankets%2C%20warm%20cozy%20atmosphere%2C%20book%20on%20nightstand%2C%20moonlight%20through%20sheer%20curtains%2C%20cream%20and%20pink%20tones%2C%20editorial%20interior&width=1200&height=600&seq=art-det-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Ocean%20waves%20gently%20washing%20on%20sandy%20beach%2C%20soft%20pastel%20sunset%20sky%2C%20peaceful%20seascape%2C%20cream%20and%20soft%20blue%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20nature%20photography&width=1200&height=600&seq=art-det-12&orientation=landscape',
  13: 'https://readdy.ai/api/search-image?query=Professional%20headphones%20on%20minimalist%20desk%2C%20sound%20wave%20visualization%2C%20warm%20amber%20lighting%2C%20cream%20background%2C%20modern%20audio%20equipment%2C%20editorial%20product%20photography&width=1200&height=600&seq=art-det-13&orientation=landscape',
  14: 'https://readdy.ai/api/search-image?query=Cozy%20reading%20room%20with%20burning%20fireplace%2C%20rain%20on%20window%2C%20leather%20armchair%2C%20bookshelf%2C%20warm%20amber%20fire%20light%2C%20wooden%20floor%2C%20cup%20of%20tea%2C%20cream%20and%20brown%20tones%2C%20editorial%20interior%20photography&width=1200&height=600&seq=art-det-14&orientation=landscape',
  15: 'https://readdy.ai/api/search-image?query=Wooden%20hair%20brushes%20on%20cream%20marble%20surface%2C%20soft%20natural%20lighting%2C%20minimalist%20beauty%20product%20photography%2C%20warm%20beige%20tones%2C%20editorial%20style&width=1200&height=600&seq=art-det-15&orientation=landscape',
};

const ArticlePage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const article = articles.find((a) => a.id === Number(id));

  if (!article) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
            <i className="ri-file-unknow-line text-2xl"></i>
          </div>
          <h2 className="text-xl font-heading font-semibold text-foreground-900 mb-2">文章未找到</h2>
          <Link to="/" className="text-sm text-primary-600 hover:text-primary-700">返回首页</Link>
        </div>
      </div>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, 3);

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: { '@type': 'Person', name: article.author },
    datePublished: article.date,
    url: `https://asmr-geek-center.com/article/${article.id}`,
    publisher: {
      '@type': 'Organization',
      name: 'ASMR基佬中心',
    },
    image: articleDetailThumbnails[article.id] || articleDetailThumbnails[1],
  };

  return (
    <div className="min-h-screen bg-background-50 pt-16">
      <script type="application/ld+json">{JSON.stringify(articleJsonLd)}</script>
      <article>
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: article.category, href: `/category/${article.categorySlug}` },
              { label: article.title },
            ]}
          />

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-4 flex-wrap">
              <span className="px-3 py-1 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                {article.category}
              </span>
              <span className="text-sm text-foreground-400">{article.readTime}</span>
              <div className="flex items-center gap-1 text-sm text-foreground-400">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-eye-line"></i></div>
                {article.viewCount > 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount}
              </div>
            </div>

            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight mb-4">
              {article.title}
            </h1>

            <div className="flex items-center gap-4 mb-8">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-primary-700 text-sm font-medium">{article.author[0]}</span>
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-900">{article.author}</p>
                <p className="text-xs text-foreground-500">{article.date}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-6 mb-10">
          <div className="rounded-lg overflow-hidden">
            <img
              src={articleDetailThumbnails[article.id] || articleDetailThumbnails[1]}
              alt={article.title}
              className="w-full aspect-[2/1] object-cover"
            />
          </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 md:px-6 pb-16">
          <div className="prose-custom text-foreground-800 leading-relaxed">
            {article.content.map((section, index) => {
              switch (section.type) {
                case 'heading':
                  return (
                    <h2 key={index} className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mt-10 mb-4">
                      {section.content}
                    </h2>
                  );
                case 'paragraph':
                  return (
                    <p key={index} className="text-sm md:text-base text-foreground-700 mb-4 leading-loose">
                      {section.content}
                    </p>
                  );
                case 'quote':
                  return (
                    <blockquote key={index} className="border-l-4 border-primary-400 pl-5 py-2 my-6 text-foreground-600 italic text-sm md:text-base">
                      {section.content}
                    </blockquote>
                  );
                case 'list':
                  return (
                    <ul key={index} className="list-disc pl-5 mb-4 space-y-1.5">
                      {section.items?.map((item, i) => (
                        <li key={i} className="text-sm md:text-base text-foreground-700 leading-relaxed">{item}</li>
                      ))}
                    </ul>
                  );
                default:
                  return null;
              }
            })}
          </div>

          <div className="flex flex-wrap gap-2 mt-8 pt-6 border-t border-background-200/60">
            {article.tags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 bg-background-100 text-foreground-600 text-xs rounded-full border border-background-200/60"
              >
                #{tag}
              </span>
            ))}
          </div>

          {relatedArticles.length > 0 && (
            <div className="mt-14">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-5">相关推荐</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="group p-4 rounded-lg bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-200"
                  >
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 line-clamp-2 mb-2">
                      {ra.title}
                    </h4>
                    <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">{ra.excerpt}</p>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </article>
    </div>
  );
};

export default ArticlePage;